<template>
    <div class="small-12 columns">
        <h1 class="list-title">{{ titulo }}</h1>
        <ul class="small-block-grid-1 medium-block-grid-2 large-block-grid-4 property-list imoveis-destaque">
            <Imovel :placa="imovel" :finalidade="finalidade" v-for="imovel in imoveis" :key="imovel"  />
        </ul>
    </div>
</template>
<script>
import { rest, empresa } from '@/config';
const Imovel = () => import("@/components/Imovel.vue");
export default {
    props: ['finalidade'],
    data() {
        return {
            Imoveis: []
        };
    },
    components: {
        Imovel
    },
    computed: {
        titulo() {
            return this.finalidade == 'aluguel' ? 'Destaques imóveis para locação' : 'Destaques imóveis à venda';
        },
        empresa() {
            return empresa.slug;
        },
        imoveis() {
            let imoveis = [...this.Imoveis];
            imoveis.sort(() => {
                return 0.5 - Math.random();
            });
            return imoveis.slice(0, 4);
        }
    },
    methods: {
        async loadImoveis() {
            const finalidade = this.finalidade;
            const empresa = this.empresa;
            let url = `${rest.endpoint}/${finalidade}/destaques.json?t=${Date.now()}`;
            if (finalidade == 'aluguel') {
                url = `${rest.endpoint}/${finalidade}/vila-rica/destaques.json?t=${Date.now()}`
            }
            fetch(url)
                .then(resp => resp.json())
                .then(imoveis => {
                    this.Imoveis = imoveis;
                })
                
                .catch(err => console.error);
        }
    },
    async created() {
        
        this.loadImoveis();
    }
}
</script>
